import React, { useState } from 'react'
import Marquee from 'react-fast-marquee'
import { useAnnouncements } from './hooks'
import Modal from '../modal'

export default function Announcement() {
  const announcements = useAnnouncements()
  const announcement = announcements?.[0]
  const [modalShow, setModalShow] = useState<boolean>(false)

  if (!announcement) return null

  const handleClick = () => {
    setModalShow(true)
  }

  const handleClose = () => {
    setModalShow(false)
  }

  return (
    <>
      <Marquee>
        <span onClick={handleClick}>{announcement.content}</span>
      </Marquee>
      <Modal isShow={modalShow} onClose={handleClose} title='公告' closable>
        <div className='m-4'>
          <div className="mb-3">
            <span className='font-bold text-lg'>{announcement?.title}</span>
          </div>
          <div>
            <span>{announcement?.content}</span>
          </div>
        </div>
      </Modal>
    </>
  )
}
